/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Interactant } from './Interactant';
import {
    InteractantFromJSON,
    InteractantFromJSONTyped,
    InteractantToJSON,
    InteractantToJSONTyped,
} from './Interactant';

/**
 * 
 * @export
 * @interface BinaryInteraction
 */
export interface BinaryInteraction {
    /**
     * 
     * @type {Interactant}
     * @memberof BinaryInteraction
     */
    firstInteractant: Interactant;
    /**
     * 
     * @type {Interactant}
     * @memberof BinaryInteraction
     */
    secondInteractant: Interactant;
    /**
     * 
     * @type {boolean}
     * @memberof BinaryInteraction
     */
    organismsDiffer: boolean;
    /**
     * 
     * @type {number}
     * @memberof BinaryInteraction
     */
    numExperiments: number;
}

/**
 * Check if a given object implements the BinaryInteraction interface.
 */
export function instanceOfBinaryInteraction(value: object): value is BinaryInteraction {
    if (!('firstInteractant' in value) || value['firstInteractant'] === undefined) return false;
    if (!('secondInteractant' in value) || value['secondInteractant'] === undefined) return false;
    if (!('organismsDiffer' in value) || value['organismsDiffer'] === undefined) return false;
    if (!('numExperiments' in value) || value['numExperiments'] === undefined) return false;
    return true;
}

export function BinaryInteractionFromJSON(json: any): BinaryInteraction {
    return BinaryInteractionFromJSONTyped(json, false);
}

export function BinaryInteractionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinaryInteraction {
    if (json == null) {
        return json;
    }
    return {
        
        'firstInteractant': InteractantFromJSON(json['firstInteractant']),
        'secondInteractant': InteractantFromJSON(json['secondInteractant']),
        'organismsDiffer': json['organismsDiffer'],
        'numExperiments': json['numExperiments'],
    };
}

export function BinaryInteractionToJSON(json: any): BinaryInteraction {
    return BinaryInteractionToJSONTyped(json, false);
}

export function BinaryInteractionToJSONTyped(value?: BinaryInteraction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstInteractant': InteractantToJSON(value['firstInteractant']),
        'secondInteractant': InteractantToJSON(value['secondInteractant']),
        'organismsDiffer': value['organismsDiffer'],
        'numExperiments': value['numExperiments'],
    };
}

